// NPM Dependencies
import { call, put, takeLatest } from 'redux-saga/effects';

// Redux Actions
import { 
	fetchDashboardContactsSuccess, 
	fetchDashboardContactsFailed 
} from '../actions/dashboardActionDispatcher';

// Config & Constants
import { DASHBOARD_CONST } from '../actionConstants';
import { APPLICATION_CONSTANTS, PATHS } from '../../AppConstants';

// APIs
import { getDashboardContacts } from '../../apis/dashboardApis';

// Utils
import { saveServerLogs } from '../../UtilityComponents/Util';

// Saga worker function
function* fetchDashboardContactsSaga() {
	try {
		const response = yield call(getDashboardContacts);
		const { data } = response || {};
		
		if (data && data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE && data.groups) {
			yield put(fetchDashboardContactsSuccess(data.groups));
		} else {
			yield put(fetchDashboardContactsFailed('Failed to fetch contacts'));
		}
	} catch (error) {
		yield put(fetchDashboardContactsFailed(error.message || 'Something went wrong, please try again later'));
		saveServerLogs(error.stack, 'error', PATHS.CORP_SUPPORT_CONTACTS);
	}
}

// Saga watcher - exports array of watchers
export default [
	takeLatest(DASHBOARD_CONST.CONTACTS_CALL_IN_PROGRESS, fetchDashboardContactsSaga)
];

